import React from 'react'
import styled from 'styled-components'
import {theme} from '../theme'
import {ElectionLogo} from '../elements/ElectionLogo'

export class NotFoundPage extends React.Component {
  render() {
    return (
      <Container>
        <ElectionLogo />
        <div>
          Oletko ehdolla tulevissa vaaleissa? Jos et ole saanut linkkiä vaalikoneeseen kirjautumiseen, saat sen puolueesi yhteyshenkilöltä.
          <span>
            {' '}
            Tarvittaessa voit kysyä apua vaalikoneen <a href="mailto:palaute.vaalikone@almamedia.fi"> ehdokastuesta</a>.
          </span>
        </div>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  padding: 3rem;
  font-size: ${theme.fontSize.large};
  a {
    color: ${theme.color.red};
  }
`
